<template>
  <div class="stat-cont">
    <div class="stat-cont-tit">出勤率</div>
    <div class="stat-cont-btm">
      <div class="stat-cont-item">
        <div class="stat-top">
          <span class="stat-number" v-cloak>{{StudentNum === '' ? 0 : StudentNum.Ratio }}</span>
          <span class="stat-unit">%</span>
        </div>
        <div class="stat-btm">出勤</div>
      </div>
      <div class="stat-cont-item">
        <div class="stat-top">
          <span class="stat-number" v-cloak>{{StudentNum === '' ? 0 : (100 - StudentNum.Ratio).toFixed(1) }}</span>
          <span class="stat-unit">%</span>
        </div>
        <div class="stat-btm">缺勤</div>
      </div>
    </div>
    <div class="stat-line-box">
      <div class="stat-left"></div>
      <div class="stat-line"></div>
      <div class="stat-right"></div>
    </div>
  </div>
</template>
<script>
export default {
  name: "Attendance",
  data() {
    return {};
  },
  props: ["StudentNum"],
  created() {},
  mounted() {},

  methods: {}
};
</script>
<style lang="less" scoped>
.stat-select {
  background: #fff;
  overflow: hidden;
  margin-bottom: 20px;
}
.stat-cont {
  background: #fff;
  overflow: hidden;
  margin: 0 20px;
  .stat-cont-tit {
    font-size: 32px;
    font-weight: 500;
    color: rgba(22, 22, 22, 1);
    margin-top: 14px;
    margin-left: 20px;
    font-family: PingFangSC-Medium, PingFang SC;
  }
  .stat-cont-btm {
    width: 100%;
    margin-top: 60px;
    margin-bottom: 58px;
    .stat-cont-item {
      display: inline-block;
      width: 50%;
      text-align: center;
      .stat-top {
        width: 70%;
        margin: 0 auto;
        .stat-number {
          font-size: 48px;
          font-family: PingFang-SC-Bold, PingFang-SC;
          font-weight: bold;
          color: rgba(22, 22, 22, 1);
        }
        .stat-unit {
          font-size: 24px;
          font-family: PingFang-SC-Regular, PingFang-SC;
          font-weight: 400;
          color: rgba(96, 96, 96, 1);
        }
      }
      .stat-btm {
        width: 70%;
        margin: 10px auto;
        font-size: 24px;
        font-family: PingFang-SC-Regular, PingFang-SC;
        font-weight: 400;
        color: rgba(96, 96, 96, 1);
      }
    }
  }
}
.stat-line-box {
  position: relative;
  .stat-line {
    border: 3px #d7d7d7 dashed;
    margin-bottom: 40px;
  }
  .stat-left {
    width: 30px;
    height: 30px;
    background: #000;
    border-radius: 50%;
    position: absolute;
    top: -13px;
    left: -13px;
    background: rgba(246, 246, 246, 1);
  }
  .stat-right {
    width: 30px;
    height: 30px;
    background: #000;
    border-radius: 50%;
    position: absolute;
    top: -13px;
    right: -13px;
    background: rgba(246, 246, 246, 1);
  }
}
</style>